import React from "react";
import "./Common_Banner.css";

const Common_Banner = ({ imgSrc, title_text,}) => {
  return (
    <section className="Common_Banner">
      <div className="img_holder">
        <img src={imgSrc} className="banner_img" />
      </div>

      <div className="container ">
        <div className="content_div">
          <p className="title_text">{title_text}</p>         
        </div>
      </div>

      <div className="overlay_colour"></div>
    </section>
  );
};

export default Common_Banner;
